/*
  Страница исполнительных документов с сервера (21.10.2026, требование владельца:
  «пагинация должна быть серверной, а не на фронте»).

  Раньше `GET /enforcement` отдавал ВСЕ документы, а страница сама отбирала «лежит без
  движения» и «в работе» и резала страницы в браузере. Теперь сервер отбирает часть реестра
  (`view`) ДО среза и отдаёт одну страницу с общим числом; вместе со страницей приходят суммы
  и числа реестра, их страница получает через `onPortfolio`.

  Список создаётся заново при смене части реестра (`key` на странице): это другой список, и
  читать его начинают с первой страницы. Когда документ изменился (событие, суд), страница
  меняет `version`, и текущая страница перечитывается вместе с суммами.
*/

import { useCallback } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import EnforcementTable from './EnforcementTable.jsx'
import usePagedList from './usePagedList.js'

const ALL = 'all'

export default function EnforcementList({ view, version, onPortfolio, ...actions }) {
  const load = useCallback(
    (window) =>
      api
        .enforcement({ ...window, view: view === ALL ? undefined : view })
        .then((portfolio) => ({
          items: portfolio.documents.items,
          total: portfolio.documents.total,
          portfolio,
        })),
    [view],
  )
  // `version` перечитывает текущую страницу (и суммы) после события или правки суда.
  /* Суммы реестра уходят наверх только из ПРИНЯТОГО ответа (23.10.2026, находка проверки):
     прежде их отдавал сам `load`, до проверки свежести, и ответ запоздавшего запроса, который
     хук потом отбросил, успевал затереть суммы плиток свежей страницы. `onAccepted`, а не
     эффект по ответу: суммы приходят в той же отрисовке, что и строки (`usePagedList.js`). */
  const accept = useCallback((answer) => onPortfolio(answer.portfolio), [onPortfolio])
  const { rows, error, bar } = usePagedList(load, undefined, version, null, accept)

  if (error) return <Notice error={error} />
  if (rows === null) return <Loading what="Считаем сроки" />
  if (rows.length === 0) {
    return (
      <div className="muted">
        {view === 'idle'
          ? 'Ничего не лежит без движения: все документы предъявлены или исполнены.'
          : 'В работе ничего нет: все документы на руках.'}
      </div>
    )
  }
  return <EnforcementTable rows={rows} bar={bar} {...actions} />
}
